<template>
    <div id="team" class="pagetext">
        <h1><strong>TEAM</strong></h1>
        <div>
            <h2><strong>Our Team</strong></h2>
            <div class="team" v-if="picturesLoaded">
                <b-container
                    fluid
                >
                    <b-row cols="2" cols-sm="2" cols-md="3" cols-lg="4">
                        <b-col
                            v-for="(name, i) in names"
                            :key="i"
                            col
                            no-gutters
                            class="mb-2"
                        >
                            <b-card
                                :title="name"
                                :sub-title="teamTitles[i]"
                                :img-src="pic[i]"
                                :img-alt="name"
                                img-side
                                style="height: 100%;"
                            >
                                {{biographies[i]}}
                            </b-card>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import Jonathan from '@/assets/jonathan.png';
// eslint-disable-next-line import/no-unresolved
// import Skylar from '@/assets/skylar.jpeg';
// eslint-disable-next-line import/no-unresolved
// import Krista from '@/assets/krista.png';
// eslint-disable-next-line import/no-unresolved
// import Kam from '@/assets/kam.png';
// eslint-disable-next-line import/no-unresolved
import Aria from '@/assets/aria_chernik.jpg';
// eslint-disable-next-line import/no-unresolved
import Katie from '@/assets/katie_zhou.jpg';
// eslint-disable-next-line import/no-unresolved
import Gargi from '@/assets/gargi_mahadeshwar.jpg';
// eslint-disable-next-line import/no-unresolved
import Vinitha from '@/assets/vinitha_sunkara.png';
// eslint-disable-next-line import/no-unresolved
import Carter from '@/assets/carter_zenke.jpg';

export default {
    data() {
        return {
            picturesLoaded: true,
            names: [
                'Aria Chernik, JD, PhD',
                'Jonathan Browning',
                'Katie Zhou',
                'Gargi Mahadeshwar',
                'Vinitha Sunkara',
                'Carter Zenke',
            ],
            pic: [
                Aria,
                Jonathan,
                Katie,
                Gargi,
                Vinitha,
                Carter,
            ],
            teamTitles: [
                'Faculty Lead',
                'Technology Team Lead, Project Manager',
                'Frontend Development Lead',
                'Backend Developer',
                'Backend Developer',
                'Education Consultant',
            ],
            biographies: [
                `My research and teaching focus on open design and education innovation, equity-centered pedagogies, and 
                social justice and technology. I am co-founder and co-director of the Open Design Studio at Duke. 
                I am thrilled to work on this project because I love co-designing contexts for joyful, collaborative, 
                and transformative learning.`,

                `I am a senior at Duke University, majoring in computer science and minoring in philosophy. 
                Through my work in open design over the past year, my interest in computer science has helped spark 
                a passion for education. Teach Tech NC allows me to combine these interests and work to transform 
                an increasingly important aspect of the education space.`,

                `I’m a third-year Duke student planning to major in Computer Science and minor in Psychology. 
                Outside of my studies in Durham, I have also had the opportunity to gain exposure to technology at 
                General Assembly in New York. Recently, I became a teaching assistant for an introductory computer 
                science course, and have experienced the importance of a well-structured, stimulating learning environment. 
                I hope that through Teach Tech NC, I can help bring that experience to future students and educators alike.`,

                `I’m a second-year Computer Science and Economics double major at Duke University. My passions include using 
                computer science and technology to further human rights, including the access to education. I also enjoy 
                conducting research on the role of identity in STEM education. I joined this team because of its community-based 
                mission to make technology more equitable and accessible.`,

                `I am a sophomore at Duke planning to major in Computer Science (BS) and double minor in Cultural Anthropology 
                and Visual & Media Studies. Growing up in NC, I began my computer science journey late in high school, 
                while also being heavily involved in the social sciences. The two seemed separated at the time, but at Duke 
                I have found ways for them to overlap. Teach Tech NC is one avenue for me to do that, as it will enable students 
                from my community to not just learn computer science early on, but merge it with the social sciences through ethical tech.`,

                `I developed a love for computers at a young age, but found few ways to develop that love in my schooling. 
                At Duke University, I designed my course of study to build the education I wished for, culminating my studies 
                by co-leading the design of North Carolina's first elementary computer science curriculum. After earning my Ed.M. 
                from the Harvard Graduate School of Education, I joined Harvard's faculty as the Academic Head of CS50 - a course 
                that has introduced 3M+ learners to the art of computer science.`,
            ],
        };
    },
    mounted() {
    },
};
</script>

<style scoped>
#about {
    text-align: left;
    margin-left: 5%;
    margin-right: 5%;
    margin-top: 30px;
}

p {
    font-size: 20px;
}

.team .card-body {
  color: #0e4761;
  padding: 10px;
}

img {
    object-fit: cover;
}

</style>
